import { render, staticRenderFns } from "./LoginForm.vue?vue&type=template&id=5c5f5a84&scoped=true&"
import script from "./LoginForm.vue?vue&type=script&lang=js&"
export * from "./LoginForm.vue?vue&type=script&lang=js&"
import style0 from "./LoginForm.vue?vue&type=style&index=0&id=5c5f5a84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5f5a84",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Form: require('/workspace/components/Form/index.js').default})
